<template>
    <div class="table-item">
        <table ref="table">
            <thead v-if="show_header">
                <tr>
                    <th ref="headers"
                        v-for="(column, index) in visible_columns"
                        @dragenter.prevent="checkDropColumn(index, $event)"
                        @dragover.prevent="checkDropColumn(index, $event)"
                        @dragleave.prevent="leaveDropColumn(index, $event)"
                        @dragend.prevent="releaseColumn(index, $event)"
                        @drop.prevent="dropColumn(index, $event)"
                    >
                        <div class="cell-content">
                            <div :class="{ draggable: draggable }" :draggable="draggable" @dragstart="grabColumn(index, $event)">
                                <table-column-filter
                                        :column_name="column.id"
                                        :label="column.title || column.label"
                                        :rows="filter_data"
                                        :visible_rows="visible_filter_data"
                                        :active_sort="active_sort"
                                        :active_filters="active_filters"
                                        :sort_method="column.sort_method"
                                        :comparison_filters="comparison_filters"
                                        filter_method="modal"
                                        @sort="sort"
                                        @comparison_filter="comparison_filter"
                                        @add_filter="add_filter"
                                        @remove_filter="remove_filter"
                                        @clear_filters="clear_filters"
                                ></table-column-filter>
                            </div>
                        </div>
                        <div class="column-anchor" v-if="anchorable && display_anchors">
                            <i class="fa fa-thumb-tack"
                               v-show="!column.stick"
                               @click="toggleSticky(index)"
                            ></i>
                            <i class="fa fa-times-circle"
                                v-show="column.stick"
                                @click="toggleSticky(index)"
                            ></i>
                        </div>
                        <div class="table-item-resize-handle"
                            @mousedown.prevent="startResize(index, $event)"
                             v-if="resize_columns"
                        ></div>
                        <div class="column-separator"></div>
                    </th>
                </tr>
            </thead>
            <tbody v-if="show_body">
                <tr v-for="(row, index) in rows"
                    ref="rows"
                    @mouseenter="hoverRow(index, true)"
                    @mouseleave="exitRow(index, true)"
                    @click="rowClicked(index)"
                    class="border_bottom"
                >
                    <td v-for="column in visible_columns">
                        <div class="cell-content color" v-if="typeof row[column.id] !== 'undefined'" :class="row[column.id].classes ? row[column.id].classes : []">
                            <div v-if="typeof row[column.id].html !== 'undefined'" v-html="row[column.id].html"></div>
                            <div v-else-if="typeof row[column.id].value !== 'undefined'">
                                {{ row[column.id].value }}
                            </div>
                        </div>
                        <div class="cell-content color" v-else-if="typeof column.color !== 'undefined'" :class="['color-' + column.color]">
                            <div> </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    $header-hor-padding: 2px;
    $column-color-0 : white;
    $column-color-1 : #dcedc8;
    $column-color-2 : #fff9c4;
    $column-color-3 : #cfd8dc;
    $column-color-4 : #ffcc80;
    $column-color-5 : #e1bee7;


    .table-item > table,
    .column-drag-image {
        th, td {
            padding: 15px 0px;
            position: relative;
        }

        thead {
            background-color: $dark-gray-blue;
            color: white;

            th {
                text-align: center;
                border-left: 2px solid $dark-gray-blue;
                padding-left: 10px;

                > .cell-content {
                    padding: 0px $header-hor-padding;
                    position: relative;
                    /*overflow: hidden;*/

                    > div.draggable {
                        cursor: grab;
                    }
                }

                &:first-child > .column-separator {
                    display: none;
                }

                .column-separator {
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    width: 1px;
                    height: 75%;
                    transform: translateY(-50%);
                    background-color: white;
                    z-index: 5;
                }

                .column-anchor {
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    height: 100%;
                    width: $header-hor-padding;
                    background-color: $dark-gray-blue;

                    i {
                        position: absolute;
                        left: 10px;
                        top: 50%;
                        transform: translateY(-50%);
                        z-index: 5;
                        cursor: pointer;
                        font-size: .75em;
                    }
                }

                &:not(:last-child) .table-item-resize-handle {
                    height: 100%;
                    width: 6px;
                    position: absolute;
                    right: -3px;
                    top: 0px;
                    cursor: ew-resize;
                    z-index: 10;
                }
            }
        }

        tbody {
            tr:nth-child(even) {
                background-color: #f3f3f3;

                td {
                    // border-left: 2px solid $light-blue;
                }
            }

            tr:nth-child(odd) {
                background-color: white;

                td {
                  //  border-left: 2px solid white;
                }
            }

            tr.is-hovering {
               // color: white;
               // background-color: #fffad3;
                background-color: darken(#f3f3f3,5%);

                td {
                    border-color: darken(#f3f3f3,5%);
                }
            }

            tr {
                > td {
                  padding:0px;
                    > .cell-content {
                        padding: 8px;
                        > div {
                            min-height:21px;
                            text-align: center;
                          }
                        &.outlier{
                            color: red;
                        }
                        &.color{
                            &.color-0{
                                background: $column-color-0;
                            }
                            &.color-1{
                                background: $column-color-1;
                            }
                            &.color-2{
                                background: $column-color-2;
                            }
                            &.color-3{
                                background: $column-color-3;
                            }
                            &.color-4{
                                background: $column-color-4;
                            }
                            &.color-5{
                                background: $column-color-5;
                            }
                        }
                    }
                }
            }
        }
    }

    .column-drag-image {
        position: absolute;
        left: -1000px;
        top: -1000px;
        opacity: 0.9;

        th {
            border: 2px solid $med-blue !important;
        }

        th .column-anchor {
            visibility: visible !important;
        }

        th .table-item-right-options {
            visibility: hidden;
        }
    }

</style>

<script>
    export default{
        props: {
            rows: { default () { return [] }},
            filter_data: { default () { return {} }},
            visible_filter_data: { default () { return {} }},
            active_sort: { default: null },
            active_filters: { default() { return {} }},
            columns: { default () { return [] }},
            sticky_only: { default: false },
            show_header: { default: true },
            show_body: { default: true },
            sortable: { default: true },
            anchorable: { default: false },
            display_anchors: { default: true },
            draggable: { default: false },
            resize_columns: { default: true },
            comparison_filters: { default () { return {} }},
        },

        computed: {
            // Only if we're sticky, also sticky.
            // Even if we're not sticky_only, we still render the sticky columns.
            visible_columns() {
                return this.columns.filter(column => {
                    return !this.sticky_only || (this.sticky_only && column.stick);
                })
            }
        },

        methods: {

            /*********************************************
            Hover Rows
            **********************************************/
            hoverRow: function(rowIndex, emit) {
                this.$emit('toggle_hover', rowIndex, true);
            },

            exitRow: function(rowIndex, emit) {
                this.$emit('toggle_hover', rowIndex, false);
            },

            /*********************************************
            Drag and Drop Columns
            **********************************************/
            grabColumn: function(columnIndex, event) {
                if (!this.draggable) return

                this.$emit('grab_column',columnIndex,event);
            },

            checkDropColumn: function(columnIndex, event) {
                this.$emit('check_drop_column',columnIndex,event);
            },

            leaveDropColumn: function(columnIndex, event) {
                this.$emit('leave_drop_column',columnIndex,event);
            },

            releaseColumn: function(columnIndex, event) {
                this.$emit('release_column',columnIndex,event);
            },

            dropColumn: function(columnIndex, event) {
                this.$emit('drop_column',columnIndex,event);
            },

            /*********************************************
            Manage Sticky Columns
            **********************************************/
            toggleSticky: function(columnIndex) {
                this.$emit('toggle_sticky', columnIndex);
            },

            /*********************************************
            Sort Column
            **********************************************/
            sort (sort_info) {
                this.$emit('sort',sort_info);
            },

            add_filter (filter_info) {
                this.$emit('add_filter',filter_info);
            },

            remove_filter (filter_info) {
                this.$emit('remove_filter',filter_info);
            },

            clear_filters (filter_info) {
                this.$emit('clear_filters',filter_info);
            },

            comparison_filter (filter_info) {
                this.$emit('comparison_filter',filter_info)
            },

            /*********************************************
            Resize Column
            **********************************************/
            startResize: function(columnIndex, event) {
                this.$emit('start_resize',columnIndex, event);
            },

            rowClicked: function (index) {
                this.$emit('row_clicked',index);
            },
            cellColor: function(color){
                return 'color-'+row[column.id].color;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// table-item.vue?292bb4c1